export class GroupInstance {
    public Group: string;
    public InstanceId: number;
}
